import useStaffData from "@app/data-hooks/use-staff-data.ts";
import useAuth from "@app/hooks/use-auth.ts";
import { Button, Grid2, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useForm } from "@tanstack/react-form";
import { QueryStatusRouter } from "bi-lib";
import moment from "moment";
import { useMemo } from "react";

export default function AccountPersonalForm() {
    const { userData } = useAuth();

    const staffId = useMemo(() => userData?.UserId, [userData]);

    const { staff, savePersonal } = useStaffData({ id: staffId });

    const form = useForm({
        defaultValues: {
            hiredDate: staff.data?.hiredDate == undefined ? undefined : moment(staff.data?.hiredDate),
            terminationDate: staff.data?.terminationDate == undefined ? undefined : moment(staff.data?.terminationDate),
            birthDate: staff.data?.birthDate == undefined ? undefined : moment(staff.data?.birthDate),
            spouseName: staff.data?.spouseName,
            emergencyContactName: staff.data?.emergContactName,
            emergencyContactPhone: staff.data?.emergContactPhone,
            socialSecurityNumber: staff.data?.socialSecurityNumber,
            notes: staff.data?.notes,
        },
        onSubmit: ({ value }) => {
            savePersonal.mutate({
                hiredDate: value.hiredDate?.format("MM/DD/YYYY"),
                terminationDate: value.terminationDate?.format("MM/DD/YYYY"),
                birthDate: value.birthDate?.format("MM/DD/YYYY"),
                spouseName: value.spouseName,
                emergContactName: value.emergencyContactName,
                emergContactPhone: value.emergencyContactPhone,
                socialSecurityNumber: value.socialSecurityNumber,
                notes: value.notes,
            });
        },
    });

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                void form.handleSubmit();
            }}
        >
            <QueryStatusRouter queryHook={staff}>
                <Grid2 container spacing={1}>
                    <Grid2 size={4}>
                        {/* @ts-expect-error TanStack Form */}
                        <form.Field name={"hiredDate"}>
                            {(field) => (
                                <DatePicker
                                    label={"Hire Date"}
                                    value={field.state.value}
                                    onChange={(e) => field.handleChange(e ?? undefined)}
                                    sx={{ width: "100%" }}
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={4}>
                        <form.Field name={"terminationDate"}>
                            {(field) => (
                                <DatePicker
                                    label={"Termination Date"}
                                    value={field.state.value}
                                    onChange={(e) => field.handleChange(e ?? undefined)}
                                    sx={{ width: "100%" }}
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={4}>
                        <form.Field name={"birthDate"}>
                            {(field) => (
                                <DatePicker
                                    label={"Birth Date"}
                                    value={field.state.value}
                                    onChange={(e) => field.handleChange(e ?? undefined)}
                                    sx={{ width: "100%" }}
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={6}>
                        <form.Field name={"socialSecurityNumber"}>
                            {(field) => (
                                <TextField
                                    label={"Social Security Number"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                    fullWidth
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={6}>
                        <form.Field name={"spouseName"}>
                            {(field) => (
                                <TextField
                                    label={"Spouse's Name"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                    fullWidth
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={6}>
                        <form.Field name={"emergencyContactName"}>
                            {(field) => (
                                <TextField
                                    label={"Emergency Contact"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                    fullWidth
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={6}>
                        <form.Field name={"emergencyContactPhone"}>
                            {(field) => (
                                <TextField
                                    label={"Emergency Phone"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                    fullWidth
                                />
                            )}
                        </form.Field>
                    </Grid2>
                    <Grid2 size={12}>
                        <form.Field name={"notes"}>
                            {(field) => (
                                <TextField
                                    label={"Notes"}
                                    value={field.state.value ?? ""}
                                    onChange={(e) => field.handleChange(e.target.value)}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                />
                            )}
                        </form.Field>
                    </Grid2>
                </Grid2>
            </QueryStatusRouter>
            <Button variant={"contained"} type={"submit"} sx={{ mt: 1 }} fullWidth>
                Save
            </Button>
        </form>
    );
}
